import { useEffect } from 'react';

export default function useOnMount(callback) {
  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(callback, []);
}
